import { ECountry } from '@portals/help-center-core';

export const getValidCountry = (country: ECountry): ECountry => {
  if (country === ECountry.CHINA) {
    return 'cn' as ECountry;
  }

  return country;
};
